import { TwoFactorAuthTypesApiPaths } from '@affiliate-cabinet/types'

import { resolveDomain, RestClient } from '../../../utils'
import { AuthorizationStatusType } from './types'

const client = new RestClient(TwoFactorAuthTypesApiPaths.GetApiAuthIsauthorized, {}, resolveDomain(), {
  mode: 'cors',
  referrerPolicy: 'no-referrer',
})

export const checkIsAuthorizedHandler = async () => client.get<AuthorizationStatusType>('')
